<div class="title">
  <h2>{{ 'list_user_entity_title' | translate }}</h2>
  <button mat-mini-fab color="accent" [matMenuTriggerFor]="menuEu">
    <mat-icon>add</mat-icon>
  </button>

  <mat-menu #menuEu="matMenu">
    <a (click)="onClickNewItem()" mat-menu-item>{{ 'list_user_entity_create_eu' | translate }}</a>
    <a (click)="onClickFusionEu()" mat-menu-item>{{ 'list_user_entity_merge_eu' | translate }}</a>
  </mat-menu>
</div>

<div class="row">
  <div class="col">
    <mat-form-field>
      <mat-label color="accent">{{ 'ressource_list_filter_by_name' | translate }}</mat-label>
      <input matInput (keyup)="nameChanged($event.target)" />
    </mat-form-field>
  </div>
</div>

<div class="nav-scroll">
  <cdk-tree class="cdk-tree" [dataSource]="dataSource" [treeControl]="treeControl">
    <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="tree-node">
      <span [routerLink]="SiteMapUrl.MenuUserEntity + '/' + node.euId" routerLinkActive="item-active" [state]="{ euId: node.euId, memberId: memberId }"> {{ node.displayName }} [{{ node.code }}] </span>
    </cdk-nested-tree-node>

    <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: hasChild" class="tree-node">
      <div class="tree-node-title" cdkTreeNodeToggle>
        <span>{{ node.key }}</span>
        <button mat-icon-button [attr.aria-label]="'Toggle ' + node.key">
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
      </div>

      <div [class.tree-invisible]="treeControl.isExpanded(node)">
        <ng-container cdkTreeNodeOutlet></ng-container>
      </div>
    </cdk-nested-tree-node>
  </cdk-tree>
</div>
